// @flow
import TrpcLibrary from 'digicel-kaizen-library/lib/tripica-library';
import I18n from '../../../../lib/i18n';
import { formatValue } from '../../../../lib/usage-formatters';

export const getGoodwillCreditOKSubtitle = ({ parameters }: { parameters: Object }): string => {
  const positiveCredits = parameters.credit.filter(credit => Number(credit.value) > 0);

  if (positiveCredits.length !== 1) {
    return '';
  }

  const credit = positiveCredits[0];
  const unit = TrpcLibrary.getUnitMapping(credit.type);
  const value = formatValue(credit.value, unit, null, null, null);

  return I18n.t(`catalog.${credit.type}_CREDIT_DETAIL`, { value });
};

export const eventTypeToSubtitleMap: Object = {
  GOODWILL_CREDIT_OK: getGoodwillCreditOKSubtitle,
};
